import React, { Component } from 'react';
import Collapsible from 'react-collapsible';

const Squeezebox = (props) => {

    const { title, html } = props;
    const isOpen = (props.isOpen === 'true');

    return (
        <Collapsible trigger={title} triggerTagName="h2" transitionTime={200} easing="ease" classParentString="squeezebox" open={isOpen}>
            {html && <div className="squeezebox__html" dangerouslySetInnerHTML={{ __html: html }}></div>}
        </Collapsible>
    );
}

export default Squeezebox;
